export class Magistrado{
    id;
    juez;
    categoria;
    fecha_creacion;
    usuario_carga;
    numero;
  }